"use client";

import { useState } from "react";
import { ReportButton } from "./ReportButton";
import { ReportProblemModal } from "./ReportProblemModal";

interface Props {
  applicationId: number;
  vertical: string;
  insuredName?: string | null;
  size?: "sm" | "md";
  // Activity Timeline pre-fill (LIB-124) — forwarded into the report context.
  taskId?: string | null;
  carrierDisplayName?: string | null;
  coverageType?: string | null;
  quoteData?: Record<string, unknown> | null;
}

export function ReportProblemButton({
  applicationId,
  vertical,
  insuredName,
  size = "md",
  taskId,
  carrierDisplayName,
  coverageType,
  quoteData,
}: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ReportButton size={size} onClick={() => setOpen(true)} />

      <ReportProblemModal
        isOpen={open}
        onClose={() => setOpen(false)}
        applicationId={applicationId}
        vertical={vertical}
        insuredName={insuredName}
        taskId={taskId}
        carrierDisplayName={carrierDisplayName}
        coverageType={coverageType}
        quoteData={quoteData}
      />
    </>
  );
}
